<app-dialog-header [title]="confirmTitle" [additionalText]="entitiesLength ? '(' + entitiesLength + ')' : ''" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutGap="16px">
    <div [innerHTML]="confirmMessage | translate | safeHtml"></div>

    <div *ngIf="typedConfirmationKeyword" fxLayout="column" fxLayoutGap="8px">
        <span class="text-base text-[#3a3a3a]">{{ typedConfirmationLabel | translate: { keyword: typedConfirmationKeyword } }}</span>
        <mat-form-field appearance="outline" class="w-100-p">
            <input
                matInput
                autofocus
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                [ngModel]="typedConfirmationValue"
                (ngModelChange)="onTypedConfirmationChange($event)"
                (keydown.enter)="confirm()"
            />
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-white-button
        class="mr-8"
        *ngIf="!hideAdditionalActionButton"
        [label]="additionalActionButtonText"
        (onClick)="dialogRef.close({ result: true, info: 'additionalActionButtonClicked' })"
    ></app-white-button>

    <app-flat-button
        [color]="confirmButtonColor"
        (keydown.enter)="confirm()"
        *ngIf="!hideActionButton"
        [label]="actionButtonText"
        (onClick)="confirm()"
        [autofocus]="!typedConfirmationKeyword"
        [disabled]="!!typedConfirmationKeyword && !isTypedConfirmationValid"
    ></app-flat-button>
</div>
